import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserDTO } from '../share/model/UserDTO';
import { LocalStorageService } from '../share/services/local-storage.service';
import { NavigationService } from '../share/services/navigation.service';

@Injectable()
export class NoColaborateGuard implements CanActivate {

    constructor(private router: Router,
        private localStorageService: LocalStorageService,
        private navigationService: NavigationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.localStorageService.isLogged()) {
            let user: UserDTO = this.localStorageService.getUser();
            if (user.isCollaborator()) {
                return false;
            }
            return true;
        }
        this.navigationService.goToLogin();
        return false;
    }
}
